/* Hero: collection stage (concept A, 20 Oct 2026).
 * Markup + CSS: sections/tc-home-stage.liquid. The photo is a native
 * scroll-snap carousel; this adds: photos cloned from inert <template>s only
 * on approach (neighbours after the first pointerdown, never on Save-Data),
 * depth (CSS scroll-driven animations, else this rAF fallback), pills (first
 * touch tap previews, lit pill or SHOP opens; mouse, Enter and VoiceOver
 * open), a SHOP button that names the state, cross-fade on far jumps, keys,
 * mouse drag + 8 px lean, theme-editor block select. Analytics: 'tc:stage'
 * {index, handle, method, action}, consented (never for automatic moves),
 * and GA4 view_promotion / select_promotion (P.ga, 25 Oct 2026).
 * Phones and tablets (owner, 20 Oct 2026): with data-auto the stage moves
 * through the collections by itself (P.auto). Desktop never does. */
(function () {
  'use strict';
  var TC = (window.TheColor = window.TheColor || {});
  if (TC.Stage) return;
  function mq(q) { return window.matchMedia ? matchMedia(q) : { matches: false }; }
  function on(m, f) { if (m.addEventListener) m.addEventListener('change', f); else if (m.addListener) m.addListener(f); }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function $$(r, s) { return [].slice.call(r.querySelectorAll(s)); }
  function num(a) { return +a.getAttribute('data-i'); }
  var reduce = mq('(prefers-reduced-motion: reduce)'), wide = mq('(min-width: 1024px)'), fine = mq('(hover: hover) and (pointer: fine)');
  var sda = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline: view()'));
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  /* When the page itself last scrolled (31 Oct 2026, phone scroll jank). */
  var pageScrolledAt = 0;
  addEventListener('scroll', function () { pageScrolledAt = Date.now(); }, { passive: true });

  function Stage(root) {
    var q = function (s) { return root.querySelector(s); };
    this.root = root;
    this.track = q('[data-tcs-track]');
    this.slides = $$(root, '.tcs__slide');
    this.copy = this.slides.map(function (s) { return s.querySelector('.tcs__copy'); });
    this.n = this.slides.length;
    this.btn = q('[data-tcs-btn]');
    this.prog = q('[data-tcs-prog]');
    this.counts = $$(root, '[data-tcs-count]');
    this.live = q('[data-tcs-live]');
    this.rail = q('[data-tcs-rail]');
    this.links = $$(root, 'a[data-i]');
    this.pills = $$(root, '.tcs__pill[data-i]');
    this.prev = q('[data-tcs-prev]');
    this.next = q('[data-tcs-next]');
    this.cur = -1;
    this.shown = 0;
    this.touch = { t: 0 };
    this.adaptive = root.getAttribute('data-adaptive') === 'true';
    this.open = root.getAttribute('data-tap') === 'open';
    this.depth = root.classList.contains('tcs--depth');
    this.reviews();
    this.thumbs();
    this.hold();
    if (this.n < 2 || !this.track) return;
    root.classList.toggle('tcs--sda', sda);
    root.classList.toggle('is-fine', fine.matches);
    this.bind();
    this.set(0, true);
    this.auto();
    var self = this;
    this.ga('view_promotion', 0);
    document.addEventListener('tc:consent-granted', function () { self.ga('view_promotion', self.shown); });
  }
  var P = Stage.prototype;

  /* Phone scroll jank (31 Oct 2026): the hero is sized to the first screen
     (100svh less the header). Some phone browser apps hide their toolbar by
     resizing the page as it scrolls, so 100svh grew mid-scroll and the hero,
     its dock and everything below jumped by the toolbar's height, right where
     the hero hands over to the page. The screen height is read once after the
     first paint and again only when the width changes (the phone turns) or a
     desktop window is resized, so a toolbar or keyboard coming and going no
     longer moves anything. Without this script the CSS keeps 100svh. */
  P.hold = function () {
    var root = this.root, w = -1, probe = document.createElement('div');
    var narrow = mq('(max-width: 1023px)'), short = mq('(max-width: 1023px) and (max-height: 600px)');
    probe.setAttribute('aria-hidden', 'true');
    probe.style.cssText = 'position:fixed;top:0;left:0;width:0;height:100vh;height:100svh;visibility:hidden;pointer-events:none';
    function read() {
      w = innerWidth;
      document.body.appendChild(probe);
      var h = probe.offsetHeight;
      document.body.removeChild(probe);
      if (h > 0) {
        root.style.setProperty('--tcs-vh', h + 'px');
        /* the short-screen layout (no peek, slimmer dock) is held with it */
        root.classList.toggle('is-vh-short', narrow.matches && short.matches);
        root.classList.toggle('is-vh-tall', narrow.matches && !short.matches);
        root.classList.add('is-vh-held');
      }
    }
    requestAnimationFrame(read);
    addEventListener('resize', function () { if (innerWidth !== w || fine.matches) read(); });
  };

  /* "★ 4.9 · 139 reviews" → the reviews widget on this page (as hero-homepage). */
  P.reviews = function () {
    var link = this.root.querySelector('[data-tc-reviews-link]');
    if (!link) return;
    function go() {
      if (document.getElementById('reviews')) return;
      var w = document.querySelector('.jdgm-reviews-grid-widget, .jdgm-all-reviews-widget, .jdgm-carousel-widget, .jdgm-featured-carousel-widget');
      if (!w) return link.removeAttribute('href');
      var host = w.closest('.shopify-section') || w.parentNode, a = document.createElement('span');
      a.id = 'reviews';
      a.style.cssText = 'display:block;height:0;overflow:hidden';
      host.insertBefore(a, host.firstChild);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  };

  /* Dock thumbnails: after the hero photo has loaded (or failed, or the page
     has), and then only the ones that can be seen in the dock; the rest load
     as the dock is scrolled to them (v2, 20 Oct 2026). Desktop has no dock,
     so it loads none. */
  P.thumbs = function () {
    var imgs = $$(this.root, 'img[data-src]'), hero = this.root.querySelector('[data-tcs-hero]'), rail = this.rail, done = 0;
    function show(im) { im.decoding = 'async'; im.setAttribute('fetchpriority', 'low'); im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); }
    function go() {
      if (done++) return;
      if (!rail || !('IntersectionObserver' in window)) return imgs.forEach(show);
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); show(e.target); } });
      }, { root: rail });
      imgs.forEach(function (im) { io.observe(im); });
    }
    if (!imgs.length) return;
    if (!hero || hero.complete) return go();
    hero.addEventListener('load', go);
    hero.addEventListener('error', go);
    addEventListener('load', go);
  };

  /* Clone state k's photo for this screen size; resolves once decoded. */
  P.load = function (k, low) {
    var sl = this.slides[k], v = wide.matches ? 'd' : 'm';
    if (!sl || !k) return Promise.resolve();
    if (sl.__v === v) return sl.__p;
    var t = sl.querySelector('template[data-' + v + ']'), src = t && t.content.querySelector('img');
    if (!src) { t = sl.querySelector('template[data-m]'); src = t && t.content.querySelector('img'); }
    if (!src) return Promise.resolve();
    var img = src.cloneNode(true), m = sl.firstElementChild, old = m.querySelector('img');
    img.decoding = 'async';
    if (low) img.setAttribute('fetchpriority', 'low');
    if (old) m.removeChild(old);
    m.appendChild(img);
    sl.__v = v;
    return (sl.__p = (img.decode ? img.decode() : Promise.resolve()).catch(function () {}));
  };
  P.warm = function (i) {
    if (this.warmed && !saveData) { this.load(i + 1, 1); this.load(i - 1, 1); }
  };

  /* Scroll → depth, active state, photos on approach. */
  P.frame = function () {
    this.raf = 0;
    var f = this.track.scrollLeft / (this.track.clientWidth || 1), lo = Math.floor(f), hi = Math.ceil(f);
    this.load(lo);
    this.load(hi);
    this.set(Math.max(0, Math.min(this.n - 1, Math.round(f))));
    if (!this.depth || sda || reduce.matches) return;
    for (var k = Math.max(0, lo - 1); k <= Math.min(this.n - 1, hi + 1); k++) {
      var p = Math.max(-1, Math.min(1, k - f)), a = Math.abs(p), c = this.copy[k], still = a < 0.001;
      this.slides[k].firstElementChild.style.transform = still ? '' : 'translate3d(' + (-14 * p).toFixed(2) + '%,0,0) scale(' + (1 + 0.08 * a).toFixed(4) + ')';
      if (c) {
        c.style.transform = still ? '' : 'translate3d(' + (22 * p).toFixed(2) + '%,0,0)';
        c.style.opacity = still ? '' : String(Math.max(0, 1 - 2.2 * a));
      }
    }
  };

  P.set = function (i, init) {
    if (i === this.cur && !init) return;
    var self = this, last = this.cur >= 0 && this.slides[this.cur].querySelector('.tcs__media img');
    if (last) last.style.transform = '';
    this.cur = i;
    this.links.forEach(function (a) { a.setAttribute('aria-current', String(num(a) === i)); });
    this.slides.forEach(function (s, k) {
      if (k === i) { s.removeAttribute('inert'); if (!k) self.keepH1(s, false); }
      else if (!k) { s.removeAttribute('inert'); self.keepH1(s, true); }
      else s.setAttribute('inert', '');
    });
    var pad = function (n) { return (n < 10 ? '0' : '') + n; }, txt = i ? pad(i) + ' / ' + pad(this.n - 1) : this.n - 1 + ' ' + (this.root.getAttribute('data-tcs-noun') || 'collections');
    this.counts.forEach(function (c) { c.textContent = txt; });
    if (this.prog) this.prog.style.setProperty('--p', String(i / (this.n - 1)));
    if (this.prev) this.prev.disabled = !i;
    if (this.next) this.next.disabled = i === this.n - 1;
    var pill = this.pills[i], r = this.rail;
    if (pill && r && !init && r.scrollWidth > r.clientWidth) {
      r.scrollTo({ left: Math.max(0, pill.parentNode.offsetLeft - (parseFloat(getComputedStyle(r).paddingLeft) || 16)), behavior: reduce.matches ? 'auto' : 'smooth' });
    }
    if (this.say && this.live) { this.live.textContent = this.slides[i].getAttribute('aria-label'); this.say = 0; }
    this.warm(i);
    if (init) return;
    clearTimeout(this.st);
    this.st = setTimeout(function () { self.settle(); }, 120);
  };

  /* The page's only H1 is in state 0. While another state shows, state 0's
     photo, eyebrow and proof line are inert, but the H1 itself stays in the
     accessibility tree (v2, 20 Oct 2026). */
  P.keepH1 = function (s, off) {
    $$(s, '.tcs__media, .tcs__copy > :not(h1)').forEach(function (e) { if (off) e.setAttribute('inert', ''); else e.removeAttribute('inert'); });
  };

  /* At rest: the SHOP button names the state on screen (adaptive button on). */
  P.settle = function () {
    clearTimeout(this.st);
    var i = this.cur, s = this.slides[i], b = this.btn;
    if (i === this.shown || !s) return;
    this.shown = i;
    /* GA waits until the page is still (31 Oct 2026): sent as a glide ends,
       its ~13 ms of script landed in the middle of a phone's scroll. */
    var self = this;
    (function send() {
      if (Date.now() - pageScrolledAt < 800) return setTimeout(send, 400);
      (window.requestIdleCallback || function (f) { return setTimeout(f, 50); })(function () { self.ga('view_promotion', i); }, { timeout: 1500 });
    })();
    if (b && this.adaptive) {
      var old = b.querySelector('span:not(.out)'), nu = document.createElement('span');
      nu.textContent = s.getAttribute('data-cta');
      b.href = s.getAttribute('data-href');
      if (reduce.matches) { b.textContent = ''; b.appendChild(nu); }
      else {
        nu.className = 'in';
        b.appendChild(nu);
        if (old) old.className = 'out';
        requestAnimationFrame(function () { requestAnimationFrame(function () { nu.className = ''; }); });
        setTimeout(function () { $$(b, 'span.out').forEach(function (o) { b.removeChild(o); }); }, 200);
      }
    }
    this.emit(i, this.how || 'swipe', 'preview');
    this.how = null;
  };

  P.emit = function (i, method, action) {
    if (method === 'auto') return;
    if (!/(?:^|; )tc_cookie_consent=accepted(?:;|$)/.test(document.cookie)) return;
    try { document.dispatchEvent(new CustomEvent('tc:stage', { detail: { index: i, handle: (this.slides[i] && this.slides[i].getAttribute('data-handle')) || '', method: method, action: action } })); } catch (e) {}
  };

  /* GA4 (25 Oct 2026): a state that settles on screen is a view_promotion, automatic moves
     included, once per state per page view, so taps can be read per impression. Opening a
     collection (the picture, a pill or index name, the button) is a select_promotion;
     previews (a swipe or hover that stays on the page) are not. With the adaptive button off
     the button is SHOP ALL whatever the state, so it reports as 'shop_all' (alt). Consent
     from the cookie, as the best-sellers rail reads it. */
  P.ga = function (name, i, alt) {
    var s = this.slides[i];
    if (!s || typeof gtag !== 'function' || !/(?:^|; )tc_cookie_consent=accepted(?:;|$)/.test(document.cookie)) return;
    if (name === 'view_promotion') {
      this.seen = this.seen || {};
      if (this.seen[i]) return;
      this.seen[i] = 1;
    }
    var h = alt || s.getAttribute('data-handle') || 'salon';
    var nm = alt ? (this.btn && this.btn.textContent.trim()) || alt : (s.getAttribute('aria-label') || '').replace(/^\d+ of \d+: /, '');
    try {
      gtag('event', name, {
        promotion_id: 'home_stage_' + h,
        promotion_name: nm,
        creative_name: h,
        creative_slot: 'state_' + i,
        items: [{ item_id: 'home_stage_' + h, item_name: nm, index: i }]
      });
    } catch (e) {}
  };

  P.jump = function (i) { this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'auto' }); };

  /* Go to state i: one away glides, further cross-fades (no photo in between is fetched). */
  P.go = function (i, how) {
    i = Math.max(0, Math.min(this.n - 1, i));
    var self = this, w = this.track.clientWidth || 1, from = Math.round(this.track.scrollLeft / w);
    if (this.busy) return (this.queued = [i, how]);
    this.how = how;
    this.say = /key|pill|button|index/.test(how);
    if (i === from) return this.set(i);
    var p = this.load(i);
    if (reduce.matches) return this.jump(i);
    if (Math.abs(i - from) < 2) return Promise.race([p, wait(400)]).then(function () { self.track.scrollTo({ left: i * w, behavior: 'smooth' }); });
    this.busy = 1;
    this.root.classList.add('is-jumping');
    Promise.all([Promise.race([p, wait(600)]), wait(140)]).then(function () {
      self.jump(i);
      requestAnimationFrame(function () {
        self.root.classList.remove('is-jumping');
        self.busy = 0;
        var q = self.queued;
        self.queued = null;
        if (q && q[0] !== self.cur) self.go(q[0], q[1]);
      });
    });
  };

  /* Pills and index names: a first touch tap previews; otherwise they are links. */
  P.pick = function (e, a, how) {
    var i = num(a), t = this.touch;
    if (!i) { e.preventDefault(); return this.go(0, how); }
    if (!this.open && t.touch && t.i === i && Date.now() - t.t < 600 && !t.lit) { e.preventDefault(); return this.go(i, how); }
    this.emit(i, how, 'open');
    this.ga('select_promotion', i);
  };

  P.bind = function () {
    var self = this, t = this.track, drag = null;
    t.addEventListener('scroll', function () {
      if (!self.raf) self.raf = requestAnimationFrame(function () { self.frame(); });
      clearTimeout(self.st);
      self.st = setTimeout(function () { self.settle(); }, 120);
    }, { passive: true });
    t.addEventListener('scrollend', function () { self.settle(); });
    t.addEventListener('keydown', function (e) {
      var i = { ArrowRight: self.cur + 1, ArrowLeft: self.cur - 1, Home: 0, End: self.n - 1 }[e.key];
      if (i === undefined) return;
      e.preventDefault();
      self.go(i, 'key');
    });
    this.root.addEventListener('pointerdown', function (e) {
      if (!self.warmed) { self.warmed = 1; self.warm(self.cur); }
      var a = e.target.closest('a[data-i]');
      if (a) self.touch = { i: num(a), t: Date.now(), lit: num(a) === self.cur, touch: e.pointerType === 'touch' };
    }, { passive: true });
    this.links.forEach(function (a) {
      var tm, how = a.classList.contains('tcs__pill') ? 'pill' : 'index';
      a.addEventListener('click', function (e) { self.pick(e, a, how); });
      a.addEventListener('focus', function () { if (Date.now() - self.touch.t > 600) self.go(num(a), 'key'); });
      if (how === 'index') {
        a.addEventListener('mouseenter', function () { clearTimeout(tm); tm = setTimeout(function () { self.go(num(a), 'hover'); }, 90); });
        a.addEventListener('mouseleave', function () { clearTimeout(tm); });
      }
    });
    if (this.prev) this.prev.addEventListener('click', function () { self.go(self.cur - 1, 'button'); });
    if (this.next) this.next.addEventListener('click', function () { self.go(self.cur + 1, 'button'); });
    if (this.btn) this.btn.addEventListener('click', function () { self.emit(self.cur, 'button', 'open'); self.ga('select_promotion', self.shown, self.adaptive ? '' : 'shop_all'); });
    /* The whole picture is a link (24 Oct): opening it is a select too. A drag's click is
       stopped on the track before it gets here. */
    this.root.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.tcs__slide-link');
      if (a) self.ga('select_promotion', self.slides.indexOf(a.closest('.tcs__slide')));
    });

    /* Mouse: drag the photo like a finger; a short flick moves one state. */
    t.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button) return;
      drag = { x: e.clientX, l: t.scrollLeft, t: Date.now() };
      self.root.classList.add('is-dragging');
    });
    addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (Math.abs(dx) > 4) drag.moved = 1;
      t.scrollLeft = drag.l - dx;
    });
    addEventListener('pointerup', function (e) {
      if (!drag) return;
      var w = t.clientWidth || 1, dx = e.clientX - drag.x, v = Math.abs(dx) / Math.max(1, Date.now() - drag.t), to = Math.round(drag.l / w);
      if (Math.abs(dx) > w * 0.12 || (v > 0.45 && Math.abs(dx) > 24)) to += dx < 0 ? 1 : -1;
      to = Math.max(0, Math.min(self.n - 1, to));
      self.suppress = drag.moved;
      drag = null;
      self.how = 'drag';
      self.load(to);
      t.scrollTo({ left: to * w, behavior: reduce.matches ? 'auto' : 'smooth' });
      var end = function () { self.root.classList.remove('is-dragging'); t.removeEventListener('scrollend', end); };
      t.addEventListener('scrollend', end);
      setTimeout(end, 700);
    });
    t.addEventListener('click', function (e) { if (self.suppress) { e.preventDefault(); e.stopPropagation(); self.suppress = 0; } }, true);
    t.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* Mouse: the photo leans up to 8 px towards the pointer. */
    this.root.addEventListener('pointermove', function (e) {
      var img = self.slides[self.cur].querySelector('.tcs__media img');
      if (e.pointerType !== 'mouse' || !fine.matches || reduce.matches || drag || !self.depth || !img) return;
      var r = self.root.getBoundingClientRect();
      img.style.transform = 'translate3d(' + (((e.clientX - r.left) / r.width - 0.5) * 16).toFixed(1) + 'px,' + (((e.clientY - r.top) / r.height - 0.5) * 10).toFixed(1) + 'px,0)';
    });
    this.root.addEventListener('pointerleave', function () {
      var img = self.slides[self.cur].querySelector('.tcs__media img');
      if (img) img.style.transform = '';
    });
    on(wide, function () {
      self.slides.forEach(function (s, k) { if (s.__v) { s.__v = null; self.load(k); } });
      self.jump(self.cur);
    });
    on(fine, function () { self.root.classList.toggle('is-fine', fine.matches); });
    /* Width changes only (31 Oct 2026): a phone browser's toolbar hiding or
       showing as the page scrolls changes just the height, and re-snapping
       then could cut a glide short. */
    var rw = innerWidth;
    addEventListener('resize', function () {
      if (innerWidth === rw) return;
      rw = innerWidth;
      clearTimeout(self.rt);
      self.rt = setTimeout(function () { self.jump(self.cur); }, 120);
    });
  };

  /* Moves by itself on phones and tablets (owner, 20 Oct 2026): the salon
     state for (data-auto + 1 s), then each collection for data-auto ms, and
     round again; the pill row follows (P.set). The next photo is fetched
     (low priority) one step ahead.
     - Stops for good when the visitor takes over: a swipe of the photo, a
       tap on a pill or button, a key, or keyboard focus inside the hero.
     - Holds while a finger is on the hero, while less than half of it is on
       screen, while the page is being scrolled (31 Oct 2026: a glide during
       a phone's scroll fought it for the main thread, so both stuttered),
       while the tab is hidden, and while a sheet or menu has the page locked
       (pop-up, cart, menu); then waits a full step.
     - Never starts with reduced motion or Save-Data, nor from 1024 px.
     - The button by the count pauses and plays it (WCAG 2.2.2). The pop-up's
       home rule listens for real taps and keys only, so moves made here
       never open it. */
  P.auto = function () {
    var self = this, root = this.root, ms = +root.getAttribute('data-auto') || 0, btn = root.querySelector('[data-tcs-play]');
    if (!ms || !btn || saveData) return;
    var play = !reduce.matches, seen = true, down = false, upAt = 0, timer = 0, html = document.documentElement;
    function paint() {
      btn.classList.toggle('is-paused', !play);
      btn.setAttribute('aria-label', play ? 'Pause the collections' : 'Play the collections');
    }
    function next() { return (self.cur + 1) % self.n; }
    function arm(extra) {
      clearTimeout(timer);
      if (!play || wide.matches) return;
      self.load(next(), 1);
      timer = setTimeout(tick, (self.cur === 0 ? ms + 1000 : ms) + (extra || 0));
    }
    function tick() {
      if (!play || wide.matches) return;
      if (!seen || down || document.hidden || html.classList.contains('tc-scroll-locked') || self.busy || Date.now() - pageScrolledAt < 800) return arm();
      self.autoAt = Date.now();
      self.go(next(), 'auto');
      clearTimeout(timer);
      timer = setTimeout(function () { arm(-700); }, 700);
    }
    function stop() { if (!play) return; play = false; clearTimeout(timer); paint(); }
    btn.hidden = false;
    paint();
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      play = !play;
      paint();
      if (play) arm(); else clearTimeout(timer);
    });
    root.addEventListener('pointerdown', function (e) { if (!e.target.closest('[data-tcs-play]')) down = true; }, { passive: true, capture: true });
    function up() { if (!down) return; down = false; upAt = Date.now(); if (play) arm(); }
    addEventListener('pointerup', up, true);
    addEventListener('pointercancel', up, true);
    /* A swipe: the photo scrolls while a finger is on it, or just after. */
    this.track.addEventListener('scroll', function () { if (down || Date.now() - upAt < 900) stop(); }, { passive: true });
    /* 24 Oct 2026: the whole picture is now a link (.tcs__slide-link). A tap on it goes to the
       collection, so it is not "taking over" the carousel: it must not stop the autoplay, or the
       page comes back from the back button with the pictures standing still. */
    root.addEventListener('click', function (e) { if (e.target.closest('a, button') && !e.target.closest('[data-tcs-play], .tcs__slide-link')) stop(); }, true);
    root.addEventListener('focusin', function (e) { if (e.target.closest('.tcs__slide-link')) e.stopImmediatePropagation(); }, true);
    /* Restored from the back/forward cache: carry on moving. */
    addEventListener('pageshow', function (e) { if (e.persisted && play) { down = false; arm(); } });
    root.addEventListener('keydown', function (e) { if (!e.target.closest('[data-tcs-play]')) stop(); }, true);
    root.addEventListener('focusin', function (e) { if (!e.target.closest('[data-tcs-play]') && Date.now() - upAt > 900 && !down) stop(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var was = seen;
        seen = es[es.length - 1].intersectionRatio >= 0.5;
        if (seen && !was && play) arm();
      }, { threshold: [0, 0.5, 1] }).observe(root);
    }
    document.addEventListener('visibilitychange', function () { if (!document.hidden && play) arm(); });
    on(wide, function () { if (wide.matches) clearTimeout(timer); else if (play) arm(); });
    arm();
  };

  function init(scope) {
    $$(scope || document, '[data-tcs]').forEach(function (r) { if (!r.__tcs) r.__tcs = new Stage(r); });
  }
  TC.Stage = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var sl = e.target.closest && e.target.closest('.tcs__slide'), r = sl && sl.closest('[data-tcs]');
    if (r && r.__tcs) r.__tcs.go(r.__tcs.slides.indexOf(sl), 'editor');
  });
})();
